import {
  Component,
  OnInit,
  inject,
  signal,
  DOCUMENT,
  ChangeDetectionStrategy,
} from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { SessionExpiryService } from './core/services/auth/session-expiry.service';
import { TokenService } from './core/services/auth/token.service';
import { isSupportPage } from './core/services/support/support-paths';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css',
})
export class App implements OnInit {
  protected readonly title = signal(environment.appName.toLowerCase());
  protected readonly version = environment.version;

  private readonly sessionExpiry = inject(SessionExpiryService);
  private readonly tokenService = inject(TokenService);
  private readonly document = inject(DOCUMENT);

  ngOnInit(): void {
    // REQ-A.2: al recargar con una sesión almacenada se reprograma el logout
    // automático al vencimiento del access token — el aviso de sesión
    // expirada no depende de que se dispare una llamada HTTP. Aplica con o
    // sin refresh token: para el fiscalizador es el único mecanismo (no hay
    // refresh); para un usuario normal es el respaldo si el refresh reactivo
    // del interceptor no llega a dispararse (sesión inactiva tras recargar).
    // En modo soporte vale lo mismo para el token de soporte (sessionStorage).
    // Las páginas de soporte (/support/start, /support/ended) no programan
    // nada: ahí la sesión normal de las otras pestañas no se toca.
    if (this.tokenService.getAccessToken() && !isSupportPage(this.document.location.pathname)) {
      this.sessionExpiry.scheduleFromStoredToken();
    }
  }
}
